import React from 'react';
import Navbar from '../components/Navbar';
import Headings from '../components/Headings';
import InfoBlock from '../components/InfoBlock';
import CtaBanner from '../components/CtaBanner';
import Footer from '../components/Footer';

const Electricity = () => {
  return (
    <>
      <Navbar />
      <Headings headingName="Electricity" />
      <InfoBlock
        tagLine="Safe & Reliable Electrical Work"
        simpleText="From panel upgrades to full home wiring — our licensed electricians handle every job with safety and expertise."
      />
      <CtaBanner />
      <Footer />
    </>
  );
};

export default Electricity;
